export default function (mainColor) {
  return {
    palette: {
      primary: {
        main: mainColor
      },
      background: {
        default: mainColor
      },
    },
  }
}